import { IRule } from "store/entities/rules/interfaces";

import { BaseApi } from "../base";

export default class RuleApi extends BaseApi {
  protected readonly prefix = "rules";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get("");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (params: Partial<IRule>) => this.post("", params);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (id: string, payload: Partial<IRule>) => this.patch(`${id}`, payload);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  remove = (id: string) => this.delete(`${id}`);
}
